// extracted by mini-css-extract-plugin
module.exports = {"ok-icon":"dd31006766--ok-icon--fJk3S"};